import Component from '@glimmer/component';
import { t } from 'ember-intl';
import {
  HdsCardContainer,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { Typography } from 'core/components';
import { boxPadding, boxMargin } from 'core/modifiers';
import { classNames } from 'core/helpers';

/**
 *
 * `PageHvnsCardsLearnMore` renders static learn more content related to HashiCorp Virtual Networks (HVNS).
 *
 *
 * ```
 * <Page::Hvns::Cards::LearnMore />
 * ```
 *
 * @class PageHvnsCardsLearnMore
 *
 */
export default class PageHvnsCardsLearnMore extends Component {
  <template>
    <HdsCardContainer
      @level="mid"
      @hasBorder={{true}}
      @overflow="visible"
      data-test-hvns-cards-learn-more
    >
      <div {{boxPadding "lg"}}>
        <header data-test-hvns-cards-learn-more-header {{boxMargin "0 0 md 0"}}>
          <Typography
            @variant="h2"
            class={{classNames
              "hds-typography-display-400"
              "hds-font-weight-semibold"
              "hds-foreground-strong"
            }}
          >
            {{t "components.page.hvns.cards.learn-more.title"}}
          </Typography>
        </header>
        <Typography
          @variant="body1"
          class={{classNames
            "hds-typography-body-200"
            "hds-font-weight-regular"
            "hds-foreground-primary"
          }}
          {{boxMargin "0 0 lg 0"}}
        >
          {{t "components.page.hvns.cards.learn-more.introduction"}}
        </Typography>
        <ul class="unstyled">
          <li {{boxMargin "0 0 md 0"}}>
            <HdsLinkStandalone
              @icon="learn-link"
              @text={{t "components.page.hvns.cards.learn-more.links.hvn-docs"}}
              @href="https://cloud.hashicorp.com/docs/hcp/network"
            />
          </li>
          <li {{boxMargin "0 0 md 0"}}>
            <HdsLinkStandalone
              @icon="learn-link"
              @text={{t
                "components.page.hvns.cards.learn-more.links.aws.peering"
              }}
              @href="https://learn.hashicorp.com/tutorials/cloud/amazon-peering-hcp?in=cloud/networking"
            />
          </li>
          <li>
            <HdsLinkStandalone
              @icon="learn-link"
              @text={{t "components.page.hvns.cards.learn-more.links.aws.tgw"}}
              @href="https://learn.hashicorp.com/tutorials/cloud/amazon-transit-gateway?in=cloud/networking"
            />
          </li>
        </ul>
      </div>
    </HdsCardContainer>
  </template>
}
